<template>
  <NavigationBarTop />
  <h1 class="page-title">Map Location and Contact</h1>
      <section class="map-section">
        <h2 class="map-subtitle">Find Us</h2>
        
        <div class="map-placeholder">
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d10481.366093080476!2d-98.70772664522028!3d29.371046415069554!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x865c44fc0450b7c9%3A0x501b3651ffcf775d!2s6175%20TX-1604%20Loop%2C%20San%20Antonio%2C%20TX%2078252%2C%20USA!5e0!3m2!1sen!2scm!4v1775052548076!5m2!1sen!2scm" 
                width="600" 
                height="450" 
                style="border:0;" 
                allowfullscreen="" 
                loading="lazy" 
                referrerpolicy="no-referrer-when-downgrade">

          </iframe>
        </div>
      </section>

    <FooterBarBelow />
      
</template>

<script>
import NavigationBarTop from '../components/NavigationBarTop.vue'
import FooterBarBelow from '../components/FooterBarBelow.vue'
export default {
    components: {
        NavigationBarTop,
        FooterBarBelow
    }
}
</script>

<style>
.container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 1rem;
}
.page-head {
    /* Style for the main h2 heading */
    font-size: 2rem;
    color: #1c1917;
    margin-top: 2rem;
    margin-bottom: 1rem;
    text-align: left; /* Ensure it stays left-aligned */
}

.map-section {
    margin-bottom: 3rem;
}

.map-subtitle {
    /* Indented H3 for the Map Title */
    font-size: 1.5rem;
    color: #333;
    font-weight: 600;
    margin-left: 1rem; /* Slightly indented */
    margin-bottom: 0.5rem;
}

.map-placeholder {
    /* Container for the Google Maps iframe */
    width: 100%;
    /* Sets the height for the map visual */
    height: 450px; 
    background-color: #eee;
    border: 1px solid #ccc;
    display: flex;
    justify-content: center;
    border-radius: 12px;
    align-items: center;
    color: #666;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    overflow: hidden; /* Prevents iframe scrollbars if size is constrained */
}


.map-placeholder iframe {
    width: 100%;
    height: 100%;
    border: none;
}
</style>